/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
export default {

  props: { "userid": String },
  async mounted() {
    console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
    await this.Disablemenu();
    this.selecteduser = this.userid
    console.log("user id", this.selecteduser)
    // await this.getCountries();
    await this.retrieveinfo();


  },
  async unmounted(){
    await this.Enablemenu();
  },
  data() {
    return {
   
      baseurl: process.env.VUE_APP_Service_URL,
      localurl: process.env.VUE_APP_redirect,
      passwordVisible: false,
      confirmPasswordVisible: false,
      selecteduser: "",
      countryList: [
      { name: "Afghanistan", code: "AF" },
      { name: "Albania", code: "AL" },
      { name: "Algeria", code: "DZ" },
      { name: "Andorra", code: "AD" },
      { name: "Angola", code: "AO" },
      { name: "Argentina", code: "AR" },
      { name: "Armenia", code: "AM" },
      { name: "Australia", code: "AU" },
      { name: "Austria", code: "AT" },
      { name: "Azerbaijan", code: "AZ" },
      { name: "Bahamas", code: "BS" },
      { name: "Bahrain", code: "BH" },
      { name: "Bangladesh", code: "BD" },
      { name: "Belarus", code: "BY" },
      { name: "Belgium", code: "BE" },
      { name: "Belize", code: "BZ" },
      { name: "Benin", code: "BJ" },
      { name: "Bhutan", code: "BT" },
      { name: "Bolivia", code: "BO" },
      { name: "Bosnia and Herzegovina", code: "BA" },
      { name: "Botswana", code: "BW" },
      { name: "Brazil", code: "BR" },
      { name: "Brunei", code: "BN" },
      { name: "Bulgaria", code: "BG" },
      { name: "Burkina Faso", code: "BF" },
      { name: "Burundi", code: "BI" },
      { name: "Cambodia", code: "KH" },
      { name: "Cameroon", code: "CM" },
      { name: "Canada", code: "CA" },
      { name: "Chad", code: "TD" },
      { name: "Chile", code: "CL" },
      { name: "China", code: "CN" },
      { name: "Colombia", code: "CO" },
      { name: "Costa Rica", code: "CR" },
      { name: "Croatia", code: "HR" },
      { name: "Cuba", code: "CU" },
      { name: "Cyprus", code: "CY" },
      { name: "Czech Republic", code: "CZ" },
      { name: "Denmark", code: "DK" },
      { name: "Dominican Republic", code: "DO" },
      { name: "Ecuador", code: "EC" },
      { name: "Egypt", code: "EG" },
      { name: "El Salvador", code: "SV" },
      { name: "Estonia", code: "EE" },
      { name: "Ethiopia", code: "ET" },
      { name: "Fiji", code: "FJ" },
      { name: "Finland", code: "FI" },
      { name: "France", code: "FR" },
      { name: "Georgia", code: "GE" },
      { name: "Germany", code: "DE" },
      { name: "Ghana", code: "GH" },
      { name: "Greece", code: "GR" },
      { name: "Guatemala", code: "GT" },
      { name: "Honduras", code: "HN" },
      { name: "Hungary", code: "HU" },
      { name: "Iceland", code: "IS" },
      { name: "India", code: "IN" },
      { name: "Indonesia", code: "ID" },
      { name: "Iran", code: "IR" },
      { name: "Iraq", code: "IQ" },
      { name: "Ireland", code: "IE" },
      { name: "Israel", code: "IL" },
      { name: "Italy", code: "IT" },
      { name: "Jamaica", code: "JM" },
      { name: "Japan", code: "JP" },
      { name: "Jordan", code: "JO" },
      { name: "Kazakhstan", code: "KZ" },
      { name: "Kenya", code: "KE" },
      { name: "Kuwait", code: "KW" },
      { name: "Kyrgyzstan", code: "KG" },
      { name: "Laos", code: "LA" },
      { name: "Latvia", code: "LV" },
      { name: "Lebanon", code: "LB" },
      { name: "Lesotho", code: "LS" },
      { name: "Liberia", code: "LR" },
      { name: "Libya", code: "LY" },
      { name: "Liechtenstein", code: "LI" },
      { name: "Lithuania", code: "LT" },
      { name: "Luxembourg", code: "LU" },
      { name: "Madagascar", code: "MG" },
      { name: "Malawi", code: "MW" },
      { name: "Malaysia", code: "MY" },
      { name: "Maldives", code: "MV" },
      { name: "Mali", code: "ML" },
      { name: "Malta", code: "MT" },
      { name: "Mexico", code: "MX" },
      { name: "Moldova", code: "MD" },
      { name: "Monaco", code: "MC" },
      { name: "Mongolia", code: "MN" },
      { name: "Montenegro", code: "ME" },
      { name: "Morocco", code: "MA" },
      { name: "Mozambique", code: "MZ" },
      { name: "Myanmar", code: "MM" },
      { name: "Namibia", code: "NA" },
      { name: "Nepal", code: "NP" },
      { name: "Netherlands", code: "NL" },
      { name: "New Zealand", code: "NZ" },
      { name: "Nicaragua", code: "NI" },
      { name: "Niger", code: "NE" },
      { name: "Nigeria", code: "NG" },
      { name: "North Korea", code: "KP" },
      { name: "North Macedonia", code: "MK" },
      { name: "Norway", code: "NO" },
      { name: "Oman", code: "OM" },
      { name: "Pakistan", code: "PK" },
      { name: "Panama", code: "PA" },
      { name: "Papua New Guinea", code: "PG" },
      { name: "Paraguay", code: "PY" },
      { name: "Peru", code: "PE" },
      { name: "Philippines", code: "PH" },
      { name: "Poland", code: "PL" },
      { name: "Portugal", code: "PT" },
      { name: "Qatar", code: "QA" },
      { name: "Romania", code: "RO" },
      { name: "Russia", code: "RU" },
      { name: "Rwanda", code: "RW" },
      { name: "Saudi Arabia", code: "SA" },
      { name: "Senegal", code: "SN" },
      { name: "Serbia", code: "RS" },
      { name: "Singapore", code: "SG" },
      { name: "Slovakia", code: "SK" },
      { name: "Slovenia", code: "SI" },
      { name: "Somalia", code: "SO" },
      { name: "South Africa", code: "ZA" },
      { name: "South Korea", code: "KR" },
      { name: "South Sudan", code: "SS" },
      { name: "Spain", code: "ES" },
      { name: "Sri Lanka", code: "LK" },
      { name: "Sudan", code: "SD" },
      { name: "Sweden", code: "SE" },
      { name: "Switzerland", code: "CH" },
      { name: "Syria", code: "SY" },
      { name: "Taiwan", code: "TW" },
      { name: "Tajikistan", code: "TJ" },
      { name: "Tanzania", code: "TZ" },
      { name: "Thailand", code: "TH" },
      { name: "Togo", code: "TG" },
      { name: "Trinidad and Tobago", code: "TT" },
      { name: "Tunisia", code: "TN" },
      { name: "Turkey", code: "TR" },
      { name: "Turkmenistan", code: "TM" },
      { name: "Uganda", code: "UG" },
      { name: "Ukraine", code: "UA" },
      { name: "United Arab Emirates", code: "AE" },
      { name: "United Kingdom", code: "GB" },
      { name: "United States", code: "US" },
      { name: "Uruguay", code: "UY" },
      { name: "Uzbekistan", code: "UZ" },
      { name: "Venezuela", code: "VE" },
      { name: "Vietnam", code: "VN" },
      { name: "Yemen", code: "YE" },
      { name: "Zambia", code: "ZM" },
      { name: "Zimbabwe", code: "ZW" },
    ],
      values: {
        id: "",
        userName: "",
        firstName: "",
        lastName: "",
        dateOfBirth: null,
        active: true,
        emailIdPrimary: "",
        emailIdSecondary: "",
        phoneNumber: "",
        userType: "",
        role:[],
        addressLineOne: "",
        addressLineTwo: "",
        country: "",
        userId: "",
        password: "",
        confirmpassword: "",
        ispersonalinfoverified: "",
        isVerified: "",
       
      },
      validations: [false, false, false, false, false, false, false, false, false,false],
      errors: []
    };
  },
  methods: {
    async Disablemenu() {
      store.dispatch("setNavbar", false);
      const navbardefault = document.querySelector("#page-wrapper")
      navbardefault.style.width="100%"
      navbardefault.style.paddingRight="0px"
    },
    async Enablemenu() {
      store.dispatch("setNavbar", true);
    },
    togglePasswordVisibility() {
      // alert("useer passwoed",this.passwordVisible);
      this.passwordVisible = !this.passwordVisible;
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
    },
    async validate() {
      this.Validatepassword(this.values.password);
      this.Validatename(this.values.firstName, 0);
      this.Validatename(this.values.lastName, 1);
      this.values.userName = this.values.userName == null ? this.values.userName : this.values.userName.replace(/ +/g, ' ').trim();
      this.ValidateUserName(this.values.userName, 9);
      this.validPhone(this.values.phoneNumber);
      this.validDob(this.values.dateOfBirth);
      this.Validateconfirmpassword(this.values.confirmpassword);
      this.Validatematchpasswords(this.values.password, this.values.confirmpassword);

    },
    async Validatepassword(passwd) {

      let reNum = /[0-9]/;
      let reLow = /[a-z]/;
      let reUpp = /[A-Z]/;
      let spcl = /(?=.*[!@#$%^&*])/;
      if ((passwd == "") || (passwd == '') || (passwd == null)) {
        this.validations[5] = true;
        this.validations[4] = false;

      }
      else if ((passwd.length < 8) || (!reLow.test(passwd)) || (!reNum.test(passwd)) || (!spcl.test(passwd)) || (!reUpp.test(passwd))) {
        this.validations[4] = true;

        this.validations[5] = false;
      }
      else {
        this.validations[4] = true;
        this.validations[5] = true;
      }

    },

    async Validateconfirmpassword(passwd) {

      let reNum = /[0-9]/;
      let reLow = /[a-z]/;
      let reUpp = /[A-Z]/;
      let spcl = /(?=.*[!@#$%^&*])/;
      if ((passwd == "") || (passwd == '') || (passwd == null)) {
        this.validations[7] = true;
        this.validations[6] = false;

      }
      else if ((passwd.length < 8) || (!reLow.test(passwd)) || (!reNum.test(passwd)) || (!spcl.test(passwd)) || (!reUpp.test(passwd))) {
        this.validations[6] = true;

        this.validations[7] = false;
      }
      else {
        this.validations[6] = true;
        this.validations[7] = true;
      }

    },

    async Validatematchpasswords(passwd, confirmpaswd) {
      if (this.validations[4] == true && this.validations[5] == true && this.validations[6] == true && this.validations[7] == true) {
        console.log("validate paswds")
        if (passwd == confirmpaswd) {
          this.validations[8] = true;
          console.log(" paswds ok")
        }
        else {
          this.validations[8] = false;
          console.log("paswds mismatch")
        }
      }
      else {
        console.log("final condtn paswds")
        this.validations[8] = true;
      }
    },
    async validPhone(phno) {
      if (phno == "") {
        this.validations[3] = true;
      }
      else if (phno > 999999999 && phno < 10000000000) {
        this.validations[3] = true;
      }
      else {
        this.validations[3] = false;
      }
    },
    async validDob(dob) {
      console.log("date is", dob);
      let myDate = new Date(dob);
      let today = new Date();
      if (dob == "") {
        this.validations[2] = true;
      }
      else if (myDate > today) {
        this.validations[2] = false;
      }
      else {
        this.validations[2] = true;
      }
    },
    async Validatename(name, errindex) {
      let letters = /^[A-Za-z\s]*$/;
      if (name == "") {
        this.validations[errindex] = false;
      }
      else if (!letters.test(name)) {
        this.validations[errindex] = false;
      }
      else {
        this.validations[errindex] = true;
      }
    },
    async ValidateUserName(name, errindex) {
      if (name == null) {
        this.validations[errindex] = false;
      }
      else if(name.length < 5 || name.length > 10){
        this.validations[errindex] = false;
      }
      else {
        this.validations[errindex] = true;
      }
    },
    async updateUser() {
      console.log("update user", this.values);
      await this.validate();
      if (this.validations.includes(false)) {
        this.errors = this.validations;
      }
      else {
        const idtoken = store.getters.getIdToken;
        console.log("values are:", this.values);
        this.values.isPersonalInfoVerified = true;
        this.values.isVerified = true;
        if (this.values.dateOfBirth === "") {
          this.values.dateOfBirth = null;
        }
        await axios
          .put(
            `${this.baseurl}/account-core/user/updateuser`,
            {
              itemId: this.values.id,
              userName: this.values.userName,
              firstName: this.values.firstName,
              lastName: this.values.lastName,
              dateOfBirth: this.values.dateOfBirth,
              active: this.values.active,
              emailIdPrimary: this.values.emailIdPrimary,
              emailIdSecondary: this.values.emailIdSecondary,
              phoneNumber: this.values.phoneNumber,
              userType: this.values.userType,
              role: this.values.role,
              addressLineOne: this.values.addressLineOne,
              addressLineTwo: this.values.addressLineTwo,
              country: this.values.country,
              userId: this.values.userId,
              password: this.values.password,
              isVerified: true,
              isPersonalInfoVerified: true
            },
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            console.log(res);
            if (res.data === "No User Found") {
              alert("No User Found");
            } else if (res.data === "User updated Successfully") {
              alert("Verified successfully");
            }
            this.userList = res.data;
            this.$router.push(`/`);
          })
          .catch((err) => {
            if(err.response.data.detail == "Username already taken !"){
              alert(err.response.data.detail)
            }
            else if(err.response.data.messages[0].includes("The user already exists.")){
              alert("User already exists with same email id!");
            }
            else{
              alert("Something went wrong!")
            }
            console.log(err);
          });
      }
    },
    async verifyuser() {
      console.log("verify", this.values.id)
      if (this.values.isVerified != true) {
        const idtoken = store.getters.getIdToken;
        await axios
          .post(
            `${this.baseurl}/account-core/user/verifyuser`,
            {
              itemId: this.values.id
            },
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )

          .then((res) => {
            console.log(res, "verified");

          })
          .catch((err) => {
            console.log(err);
          });
      }
      else {
        //this.$router.push(`/`);
      }

    },
    async retrieveinfo() {
// this.selecteduser is the token from email
      console.log("id from apiiiiiiiiiiiiiii ");

      if (this.selecteduser != "") {

        const idtoken = store.getters.getIdToken;
        await axios
          .get(
            `${this.baseurl}/account-core/user/gettokenstatus?token=${this.selecteduser}`,
          // .get(
          //   `https://localhost:5001/user/gettokenstatus?token=${this.selecteduser}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {

            console.log("hi user from db", res.data);
            if (res.data === "No User Found") {
              alert("No User Found");
            }
            res.data.dateOfBirth = res.data.dateOfBirth === null ? "" : res.data.dateOfBirth.slice(0, 10);
            this.values = res.data;
            this.verifyuser();
            console.log("values from  db", this.values)
            this.values.password = "";
            // if (this.values.isPersonalInfoVerified) {
            //   alert("User already verified");
            //   this.$router.push(`/`);
            // }
          })
          .catch((err) => {
            console.log(err);
            alert("User already verified!");
            this.$router.push(`/`);
          });
      }
    },
    async getCountries() {
      const idtoken = store.getters.getIdToken;

      try {
        const res = await axios.get(
          `${this.baseurl}/management/patient/getallcountry`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.countryList = res.data;
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    }


  },
};
